/* OCB relaunch: open the cart drawer right after add-to-cart instead of the small header "Added to cart" bar. */
(function () {
  document.addEventListener('theme:cart:popdown', function () {
    setTimeout(function () {
      var popdown = document.querySelector('.product__popdown, [data-popdown]');
      if (popdown) popdown.classList.remove('is-visible', 'visible');
      var toggle = document.querySelector('header [data-drawer-toggle="drawer-cart"], .header [data-drawer-toggle="drawer-cart"]') ||
                   document.querySelector('[data-drawer-toggle="drawer-cart"]:not(.drawer__close)');
      if (toggle) toggle.click();
    }, 350);
  });
})();

/* OCB relaunch: gift option in cart drawer → cart attributes */
(function () {
  var timer;
  function save(root) {
    var on = root.querySelector('[data-ocb-gift-toggle]').checked;
    var msg = root.querySelector('[data-ocb-gift-message]').value;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Gift': on ? 'Yes' : '', 'Gift message': on ? msg : '' } }) })
      .then(function () { var s = root.querySelector('[data-ocb-gift-saved]'); if (s) { s.hidden = false; setTimeout(function () { s.hidden = true; }, 1500); } });
  }
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-ocb-gift-toggle]')) return;
    var root = e.target.closest('[data-ocb-gift]');
    root.querySelector('.ocb-gift__msg').hidden = !e.target.checked; save(root);
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-ocb-gift-message]')) return;
    var root = e.target.closest('[data-ocb-gift]'); clearTimeout(timer); timer = setTimeout(function () { save(root); }, 600);
  });
})();
